<template>
  <div id="shortcuts">
    <router-link
      v-for="item in list[location]"
      :key="item.title"
      tag="div"
      :to="item.url"
      class="button"
    >
      <div class="circle">
        <i :class="item.icon" />
      </div>
      <div class="title">{{ item.title }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Shortcuts",
  props: {
    location: {
      type: String,
      default: "home",
    },
  },
  data() {
    return {
      list: {
        home: [
          {
            title: "邀请购课",
            icon: "anyteachicon anyteach-yaoqing3",
            url: "/invite/reward",
          },
          {
            title: "提现钱包",
            icon: "anyteachicon anyteach-qianbao",
            url: "/cash",
          },
          // {
          //   title: "支付历史",
          //   icon: "anyteachicon anyteach-dollar-sign",
          //   url: "/payments",
          // },
          {
            title: "考试报告",
            icon: "anyteachicon anyteach-hundred",
            url: "/exams?source=front_page",
          },
          {
            title: "同城拼课",
            icon: "anyteachicon anyteach-clock1",
            url: "/homeclass",
          },
        ],
        courses: [
          {
            title: "邀请购课",
            icon: "anyteachicon anyteach-yaoqing3",
            url: "/invite/reward",
          },
          {
            title: "支付历史",
            icon: "anyteachicon anyteach-dollar-sign",
            url: "/payments",
          },
          {
            title: "考试报告",
            icon: "anyteachicon anyteach-hundred",
            url: "/exams?source=front_page",
          },
          {
            title: "自定义支付",
            icon: "anyteachicon anyteach-credit-card",
            url: "/special/-1",
          },
          {
            title: "小管家",
            icon: "anyteachicon anyteach-headset",
            url: "/contact",
          },
        ],
      },
    }
  },
}
</script>

<style scoped lang="scss">
#shortcuts {
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  width: 90%;

  .button {
    display: inline-block;
    text-align: center;
    transition: 0.1s;
    &:active {
      opacity: 0.7;
    }
    .circle {
      $size: 40px;
      $color1: $red;
      $color2: #ff6161;
      background: $red;
      // background-image: linear-gradient(to left, $color1, $color2);
      // background-image: -webkit-linear-gradient(to left, $color1, $color2);
      // background-image: -moz-linear-gradient(to left, $color1, $color2);
      // background-image: -o-linear-gradient(to left, $color1, $color2);
      // background-image: -ms-linear-gradient(to left, $color1, $color2);
      margin: auto;
      color: white;
      border-radius: $size;
      width: $size;
      height: $size;
      i {
        font-size: 17px;
      }
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title {
      margin: 5px auto 0 auto;
      line-height: 1.2;
      white-space: normal;
      color: $black;
      font-size: 0.8rem;
      @include avenir();
    }
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 320px) {
  #shortcuts .button {
    .title {
      font-size: 0.75rem;
    }
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  #shortcuts {
    // margin: 10px 5%;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  #shortcuts {
    display: block;
    .button {
      margin-right: 20px;
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>
